import request from '@/utils/request'

//查询功效分类列表
export function geteffectList() {
    return request({
      url: '/api/websiteArticle/geteffectList',
      method: 'get'
    })
  }

  //查询论文列表
export function getacademic(query) {
    return request({
        url: '/api/websiteArticle/getNewsList',
        method: 'get',
        params: query
      })
  }

 //查询论文列表前十名
 export function getacademicRanking(query) {
    return request({
        url: '/api/websiteArticle/getacademicRanking',
        method: 'get',
        params: query
      })
  }
  



// WEBPACK FOOTER //
// ./src/api/academic.js